import React, { useEffect, useMemo, useState } from "react";

import { injectStyles } from "../inject-style";

const defaultStrings = {
  allItemsAreSelected: "All items are selected.",
  clearSearch: "Clear Search",
  clearSelected: "Clear Selected",
  noOptions: "Nenhuma opção encontrada",
  search: "Search",
  selectAll: "Select All",
  selectSomeItems: "Select...",
  create: "Create",
};

const defaultProps = {
  value: [],
  hasSelectAll: true,
  className: "multi-select",
  debounceDuration: 200,
  options: [],
};

const MultiSelectContext = React.createContext();

export const MultiSelectProvider = ({
  props,
  children,
}) => {
  const [options, setOptions] = useState(props.options);
  const t = (key) => props.overrideStrings?.[key] || defaultStrings[key];

  useMemo(() => injectStyles(), []);

  useEffect(() => {
    setOptions(props.options);
  }, [props.options]);

  return (
    <MultiSelectContext.Provider
      value={{ t, ...defaultProps, ...props, options, setOptions }}
    >
      {children}
    </MultiSelectContext.Provider>
  );
};

export const useMultiSelect = () => React.useContext(MultiSelectContext);